import { render, staticRenderFns } from "./OptimizationCard.vue?vue&type=template&id=a2851654&scoped=true&"
import script from "./OptimizationCard.vue?vue&type=script&lang=ts&"
export * from "./OptimizationCard.vue?vue&type=script&lang=ts&"
import style0 from "./OptimizationCard.vue?vue&type=style&index=0&id=a2851654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2851654",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
